/* global globals, translations */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

const SubscriptionVipPaymentSummary = (props) => {
  const { data } = props;

  // Savings (with no campaign) / Discount (with campaign)
  const savings = () => {
    const value = data.campaign ? data.campaign.discount : data.savings;
    const text = data.campaign ? "txt: atlaide" : "txt: ietaupījums";
    const tcg = data.campaign ? " tcg" : "";
    //
    return (
      <div>
        <div className={`paymentOption-bigText${tcg}`}>{value}</div>
        <div className={`paymentOption-smallText${tcg}`}>
          {get(translations, text, text)}
        </div>
      </div>
    );
  };

  // Amount to pay
  const amountToPay = () => {
    // With no campaign
    if (!data.campaign) {
      return (
        <span className="paymentOption-amount">
          <span className="paymentOption-bigText">
            {data.amountToPay.toFixed(2)}
          </span>
        </span>
      );
    }
    // With campaign
    return (
      <div className="dib">
        <span className="paymentOption-amount tdlt">
          <span className="paymentOption-bigText">
            {data.amountToPay.toFixed(2)}
          </span>
        </span>
        <span className="paymentOption-amount-special tcr">
          <span className="paymentOption-bigText">{` ${data.campaign.amountToPay.toFixed(
            2
          )}`}</span>
        </span>
      </div>
    );
  };

  return (
    <div className="paymentOption-summary-wrapper">
      <div className="paymentOption-summary--wTerms">
        <div className="paymentOption-bigText mbxs">
          {get(translations, "txt: VIP abonements", "")}
        </div>
        <div className="paymentOption-line" />
        <div className="paymentOption-bigText">{data.termText}</div>
        <div className="paymentOption-line" />
        <span className="paymentOption-amount">{amountToPay()}</span>
        <span className="paymentOption-smallText">{` ${get(
          globals,
          "currency",
          ""
        )}`}</span>
        <div className="paymentOption-smallText">
          {get(translations, "txt: apmaksai", "apmaksai")}
        </div>
      </div>
      <div className="paymentTerms ptm plm tar">
        {get(globals, "currentDomainName") === "otrapuse.lv" && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/static/distances_ligums_OP_15102018.pdf"
            className="dib tar bdn tcb twb mbxs"
          >
            {get(translations, "txt: Distances līgums", "Distances līgums")}
          </a>
        )}
      </div>
    </div>
  );
};

SubscriptionVipPaymentSummary.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default SubscriptionVipPaymentSummary;
